{
  "remove": "Verwijderen"
}
